<template>
  <div class="wrapper">
    <plan-rule-list-item v-for="(value, name) in rules" :key="name" :name="name" :value="value" :model="rules[name]" :rules="rules"/>
  </div>
</template>
<script>
import PlanRuleListItem from '@/components/pages/plans/PlanRuleListItem'

export default {
  props: {
    rules: {
      type: Object
    }
  },
  components: {
    PlanRuleListItem
  }
}
</script>



// WEBPACK FOOTER //
// PlanRuleList.vue?11334d60